var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefenders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.75V5.25H1.75V7H3.5V0H5.25V1.75H7V0H8.75V1.75H10.5V0H12.25V1.75H14V0H15.75V7H17.5V5.25H19.25V15.75H11.375V13.125C11.375 12.6437 11.2035 12.2316 10.8605 11.8886C10.5175 11.5456 10.1057 11.3744 9.625 11.375C9.14375 11.375 8.73162 11.5465 8.38862 11.8895C8.04562 12.2325 7.87442 12.6443 7.875 13.125V15.75H0ZM7 7.875H8.75V5.25H7V7.875ZM10.5 7.875H12.25V5.25H10.5V7.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefenders);
export default __webpack_public_path__ + "static/media/Defenders.10e6e4fd69becb7a1c617d45847dcf95.svg";
export { ForwardRef as ReactComponent };